import {ColumnGroup} from 'src/tracker/model/column/groups/column-group'
import {acquiredColumn} from 'src/tracker/model/column/variable/acquired/acquired-column'

export const acquiredGroup = new ColumnGroup(
  '9a4cc307-7057-4988-8eba-a34bbaa0ea1a',
  '',
  [acquiredColumn]
)

